import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllDepartments = lazy(() => import("../pages/all-departments"));

export const DeparmentManagementRouter = [
  {
    path: "/master-management/department",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllDepartments />
          </Suspense>
        ),
      },
    ],
  },
];
